export default __webpack_public_path__ + "images/referrals-onboarding-step-2_2x.0af355b9fffcbdbb92beb1939d1ce38f.png";